namespace $.$$ {

	const transparent_cross = {
		content: '""',
		position: 'absolute',
		left: '-15%',
		top: '50%',
		width: '130%',
		height: '1px',
		backgroundColor: '#ff3333',
		transformOrigin: 'center',
		pointerEvents: 'none',
	} as const
	
	$mol_style_define( $shm_hitalama_color_dot, {
		
		width: '1rem',
		height: '1rem',
		borderRadius: '50%',
		position: 'relative',
		overflow: 'hidden',

		outline: 'var(--mol_theme_shade) 1px solid',

		'[shm_hitalama_color_transparent]': {
			true: {
				'::before': {
					...transparent_cross,
					transform: 'rotate(45deg)',
				},
				'::after': {
					...transparent_cross,
					transform: 'rotate(-45deg)',
				},
			},
		},
		
	} )
	
}
